




















































import { Component, Prop, Vue } from "vue-property-decorator";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import PageNavi from "@/common/components/atoms/PageNavi.vue";
import TheTemplateI from "@/general/components/templates/TheTemplateI.vue";
import IConditionsList from "@/general/components/pages/parts/GrantCriteriaList/IConditionsList.vue";
import { getGrantCriteriaList } from "@/general/store/api";
import grantcriterialist from "@/general/store/modules/grantCriteriaList";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconTrophy from "@/common/components/icons/IconTrophy.vue";
import IconNoSearchResult from "@/common/components/icons/IconNoSearchResult.vue";
import store from "@/general/store";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    TheHeader,
    TheFooter,
    CommonHeading,
    PageNavi,
    IconBase,
    IconTrophy,
    TheTemplateI,
    IconNoSearchResult,
    IConditionsList
  },
  store: store
})
export default class GrantCriteria extends Vue {
  isLoading = true;
  search = "";
  searchResultCount: number | undefined = 0;
  heading = "";
  @Prop({ type: String, default: "" }) searchKeyword!: string;

  conditionsList: Array<any> = [];

  breadcrumb: any = [];

  sorted: any = {
    target: " ",
    position: 0,
    shownState: false,
    itemList: [
      {
        id: "sorted-point-count-asc",
        value: "points",
        label: "ポイント（昇順）"
      },
      {
        id: "sorted-point-count-desc",
        value: "-points",
        label: "ポイント（降順）"
      },
      {
        id: "sorted-point-id-asc",
        value: "id",
        label: "付与基準ID（昇順）"
      },
      {
        id: "sorted-point-id-desc",
        value: "-id",
        label: "付与基準ID（降順）"
      },
      {
        id: "sorted-point-name-asc",
        value: "name",
        label: "付与基準名（昇順）"
      },
      {
        id: "sorted-point-name-desc",
        value: "-name",
        label: "付与基準名（降順）"
      }
    ]
  };

  filterHeading = "すべての期間";

  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };

  currentPage!: number;
  orderingPage!: string;
  searchPage!: string;
  slug!: string;

  showNotFound = false;

  $refs!: {
    theHeader: TheHeader;
  };

  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }
  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    await this.setConditionsList();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const pageParam = urlParams.get("page");
    const orderingParam = urlParams.get("ordering")
      ? (urlParams.get("ordering") as string)
      : "";
    const searchParam = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";
    const filter_position = urlParams.get("filter_position")
      ? parseInt(urlParams.get("filter_position") as string)
      : 0;

    const redirect_from = urlParams.get("redirect_from")
      ? (urlParams.get("redirect_from") as string)
      : "";

    this.searchKeyword = searchParam;

    this.currentPage = pageParam ? parseInt(pageParam) : 1;

    this.orderingPage = orderingParam ? orderingParam : "order_by";
    this.searchPage = searchParam ? searchParam : "";

    const response = await getGrantCriteriaList(
      this.orderingPage,
      this.currentPage,
      this.pageSize,
      this.searchPage
    );

    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }
    const nextPage = this.currentPage + 1;
    const count = response.count as number;

    this.searchResultCount = count;
    if (this.searchResultCount == 0) {
      this.showNotFound = true;
    } else {
      this.showNotFound = false;
    }
    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;

    this.conditionsList = response.results || [];
    // this.conditionsList = [];
    if (this.conditionsList.length == 0) {
      window.location.href = "/no-grant-criteria-list-found";
    }

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl = CONST_DATA.SITE_MAP.GRANT_CRITERIA + "?";
    this.conditionsList =
      response.results?.map((res: any) => {
        return {
          ...res,
          url:
            "/grant-criteria-details/?id=" +
            res?.id +
            "&ordering=" +
            orderingParam +
            "&search=" +
            searchParam +
            "&page=" +
            this.currentPage +
            "&redirect_from=" +
            redirect_from
        };
      }) || [];
    if (this.conditionsList.length == 0) {
      window.location.href = "/no-grant-criteria-list-found";
    }

    this.setBreadcrumb();
    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl = `${CONST_DATA.SITE_MAP.GRANT_CRITERIA}?ordering=${this.orderingPage}&search=${this.searchPage}&`;

    this.pageNavi.nextPageUrl = this.pageNavi.baseUrl + "page=" + nextPage;

    this.pageNavi.prevPageUrl = this.pageNavi.baseUrl + "page=" + prevPage;
    this.filterHeading = this.sorted.itemList[filter_position].label;
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  }

  setConditionsList() {
    this.conditionsList =
      grantcriterialist.GrantCriteriaListResponse?.results || [];
  }
  initSearchKeyword() {
    this.search = this.searchKeyword;
  }
  get internalSearch() {
    return this.search;
  }

  set internalSearch(newValue: string) {
    if (this.search !== newValue) this.$emit("update:search", newValue);
  }
  async doSearch($event: any) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pageParam = 1;
    const orderingParam = urlParams.get("ordering")
      ? (urlParams.get("ordering") as string)
      : "";
    const redirect_from = urlParams.get("redirect_from")
      ? (urlParams.get("redirect_from") as string)
      : "";
    window.location.href =
      `${CONST_DATA.SITE_MAP.GRANT_CRITERIA}?ordering=` +
      orderingParam +
      "&search=" +
      $event +
      "&page=" +
      pageParam +
      "&redirect_from=" +
      redirect_from;
  }
  get maxPage() {
    return this.pageNavi.maxPage;
  }

  get nextPageUrl() {
    return this.pageNavi.nextPageUrl;
  }

  get prevPageUrl() {
    return this.pageNavi.prevPageUrl;
  }

  get baseUrl() {
    return this.pageNavi.baseUrl;
  }
  get showPageNavi() {
    return this.pageNavi.maxPage > 1;
  }
  get headingForSearch() {
    const { searchResultCount, searchKeyword } = this;
    if (!searchResultCount || !searchKeyword) return "";
    return `「${this.searchKeyword}」の検索結果（${this.searchResultCount}件）`;
  }
  async doSort($event: any) {
    this.orderingPage = $event;
    this.sorted.target = this.orderingPage;
    let position = 0;

    if (this.sorted.target) {
      for (let i = 0; i < this.sorted.itemList.length; i++) {
        if (this.sorted.itemList[i].value === this.sorted.target) {
          position = i;
        }
      }
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pageParam = 1;
    const searchParam = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";
    const redirect_from = urlParams.get("redirect_from")
      ? (urlParams.get("redirect_from") as string)
      : "";

    this.searchKeyword = searchParam;
    this.search = searchParam;
    let queryUrl = `${CONST_DATA.SITE_MAP.GRANT_CRITERIA}?ordering=${this.orderingPage}`;
    queryUrl += `&search=${searchParam}&filter_position=${position}&page=${pageParam}&redirect_from=${redirect_from}`;

    if (queryUrl == window.location.search) return;

    window.location.href = queryUrl;
  }

  async setBreadcrumb() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const redirect_from = urlParams.get("redirect_from")
      ? (urlParams.get("redirect_from") as string)
      : undefined;

    if (redirect_from != undefined && redirect_from == "my-page") {
      this.breadcrumb.push(
        {
          text: "",
          url: CONST_DATA.SITE_MAP.TOP_PAGE,
          pageType: "home"
        },
        {
          text: "マイページ",
          url: CONST_DATA.SITE_MAP.MY_PAGE,
          pageType: "lower"
        },
        {
          text: "付与基準一覧",
          url: CONST_DATA.SITE_MAP.DEFAULT,
          pageType: "lower"
        }
      );
    } else if (
      redirect_from != undefined &&
      redirect_from == "point-confirmation"
    ) {
      this.breadcrumb.push(
        {
          text: "",
          url: CONST_DATA.SITE_MAP.TOP_PAGE,
          pageType: "home"
        },
        {
          text: "ポイント確認",
          url: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,
          pageType: "lower"
        },
        {
          text: "付与基準一覧",
          url: CONST_DATA.SITE_MAP.DEFAULT,
          pageType: "lower"
        }
      );
    } else {
      this.breadcrumb.push(
        {
          text: "",
          url: CONST_DATA.SITE_MAP.TOP_PAGE,
          pageType: "home"
        },
        {
          text: "付与基準一覧",
          url: CONST_DATA.SITE_MAP.DEFAULT,
          pageType: "lower"
        }
      );
    }

    await commons.getBreadcrumb(this.breadcrumb);
  }
}
